export default {"src":"/_next/static/media/successImage.c2b072b2.svg","height":630,"width":630};